import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
const DialogBody = ({ className = '', children, ...remainingProps }) => {
    const classes = classNames('modal-body', className);
    return (_jsx("div", { ...remainingProps, className: classes, "aria-label": 'dialog body', children: children }));
};
export default DialogBody;
